/* eslint-disable max-len */
export const common = {
  'pd-processing-policy-file-name': 'pd_processing_policy_kz.pdf',
  'user-agreement-sm-podbor-file-name-ru': 'user_agreement_sm_podbor_kk_ru.pdf',
  'user-agreement-sm-podbor-file-name': 'user_agreement_sm_podbor_kk.pdf',
  'accept-agreement-to-continue': 'Жалғастыру үшін дербес деректерді өңдеуге келісім беру қажет',
  'i-accept-user-data-proccesing': 'Мен өзімнің дербес деректерімді өңдеуге келісім беремін',
  yes: 'Иә',
  no: 'Жоқ',
  continue: 'Жалғастыру',
  start: 'Бастау',
  skip: 'Жалғастыру',
  delete: 'Жою',
  cancel: 'Күшін жою',
  registration: 'Тіркелу',
  russia: 'Ресей',
  ukraine: 'Украина',
  belarus: 'Беларусь',
  'cookie-agreement': 'Біз ұсыныстарды қажеттіліктеріңізге сай бейімдеу үшін және сайттағы өзара әрекеттің барынша ыңғайлылығын қамтамасыз ету үшін cookie файлдарын пайдаланамыз. <a href="/user_agreement_sm_podbor_kz.pdf" target="_blank" class="text-neutral-700 hover:underline">Cookie файлдарын пайдалану туралы көбірек білу. </a>Сайтты пайдалануды жалғастырып, Сіз cookie файлдарын пайдаланумен келісесіз.',
  'accept-and-close': 'Қабылдау және жабу',
  'action-confirmation': 'Әрекетті растау',
  'execute-action': 'Әрекет орындалсын ба?',
  ok: 'ОК',
  'choose-date': 'Күнді таңдаңыз',
  'birth-date': 'Туған күн',
  'add-resume': 'Резюме қосыңыз',
  'invalid-file-type': 'Файлдың типі жарамсыз',
  'cannot-load-stores': 'Дүкеннің деректері жүктеле алмады. Әкімшілерге хабарласыңыз.',
  'nothing-found': 'Ештеңе табылмады',
  'store-business-card': 'Дүкеннің визиткасы',
  'date-time-creation': 'Жасау күні/уақыты',
  vacancy: 'Вакансиялар',
  store: 'Дүкен',
  'file-upload-error': 'Файлды жүктеу қатесі. Қайталап көріңіз',
  'file-remove-error': 'Файлды жою қатесі. Қайталап көріңіз',
  'file-upload-success': 'Файл сәтті жүктелді',
  'file-remove-success': 'Файл сәтті жойылды',
  'file-already-uploaded': 'Сіз бұл файлды жүктеп алғансыз',
};
